export const PrimeContractorZones = [
  { _id: 'north', name: 'Prime North' },
  { _id: 'south', name: 'Prime South' },
];

export const PrimeContractorZoneNames: Record<string, string> = PrimeContractorZones.reduce<Record<string, string>>(
  (acc, zone) => {
    acc[zone._id] = zone.name;
    return acc;
  },
  {}
);
